import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  Lookup,
} from "devextreme-react/data-grid";
import Button from "devextreme-react/button";
import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/auth";
import axios from "axios";
import { backendlink } from "../../config";
import { Toast } from "devextreme-react/toast";

export default function CustomerEcgDeviceListDatagrid({ fetchTrigger }) {
  const { user } = useAuth();

  const [ecgDeviceList, setEcgDeviceList] = useState([]);

  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "success",
    message: "",
  });

  const fetchData = async (loadOptions) => {
    try {
      const page = Math.floor(loadOptions.skip / loadOptions.take) + 1;
      const size = loadOptions.take;
      const response = await axios.get(
        backendlink + "customer/getcustecgdevices",
        {
          headers: {
            token: user.token,
          },
          params: {
            page: page,
            size: size,
            organizationToken: user.userToken,
          },
        }
      );

      if (response.data.errorno === 0) {
        const outputArray = response.data.result.map((item) => {
          return {
            deviceId: item.deviceId,
            serialNo: item.serialNo,
            patientName: item.patientName,
            expiryDate: item.expiryDate,
            status: item.status,
          };
        });
        setEcgDeviceList(outputArray);
      } else {
        setEcgDeviceList([]);
        alert(response.data.errmessage);
      }
    } catch (error) {
      alert(error);
    }
  };

  function onHiding() {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  }

  useEffect(() => {
    fetchData({ skip: 0, take: 5 });
  }, [user, fetchTrigger]);

  const onUnassign = async (deviceId) => {
    if (!deviceId) {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: "error",
        message: "Device Id is missing",
      });
    } else {
      try {
        const response = await axios
          .post(
            backendlink + "customer/updatepatientecgdevices",
            {
              deviceId: deviceId,
              organizationToken: user.userToken,
              action: "unassign-from-patient",
            },
            {
              headers: {
                token: user.token,
              },
            }
          )
          .then((res) => {
            if (res.data.errorno === 0) {
              setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: "success",
                message: "Unassigned from the patient",
              });

              fetchData({ skip: 0, take: 5 });
            } else {
              setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: "error",
                message: res.data.errmessage,
              });
            }
          });
      } catch (error) {
        alert(error);
      }
    }
  };

  return (
    <React.Fragment>
      <DataGrid dataSource={ecgDeviceList}>
        <Column dataField="serialNo" caption="Device Id" alignment="left" />
        <Column dataField="patientName" caption="Assigned Patient" />
        <Column dataField="expiryDate" caption="Expiry Date" />
        <Column dataField="status" caption="Status" />
        <Column
          caption="Action"
          cellRender={({ data }) => {
            if (!data.patientName) {
              return null; // Hide button if name does not exist
            }
            return (
              <Button
                text="Unassign Device"
                stylingMode="contained"
                type="danger"
                onClick={() => onUnassign(data.deviceId)}
              />
            );
          }}
        />
        <Pager allowedPageSizes={[5, 10, 20]} showPageSizeSelector={true} />
        <Paging defaultPageSize={5} />
        <FilterRow visible={true} />
        <Lookup />
      </DataGrid>

      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={2000}
      />
    </React.Fragment>
  );
}